import { Box, SxProps, Typography } from "@outschool/backpack";
import { Trans, useTranslation } from "@outschool/localization";
import { useTrackEvent } from "@outschool/ui-analytics";
import { useSession } from "@outschool/ui-auth";
import { Loading } from "@outschool/ui-legacy-component-library";
import { pxToRem } from "@outschool/ui-utils";
// This file is not yet translated.
/* eslint-disable i18next/no-literal-string */
import { PaymentElement } from "@stripe/react-stripe-js";
import React from "react";

import { StripePaymentElementPaymentMethod } from "../../../shared/Stripe";

export default function StripePaymentElement({
  setIsPaymentElementComplete,
  setPaymentMethod,
  paymentMethod,
  payingUser,
  containerSx = {},
  willCardBeSavedAsDefault,
}: {
  setIsPaymentElementComplete: (value: boolean) => void;
  setPaymentMethod: (value: StripePaymentElementPaymentMethod) => void;
  paymentMethod: StripePaymentElementPaymentMethod;
  payingUser?: {
    name?: string;
    email?: string;
  };
  containerSx?: SxProps;
  willCardBeSavedAsDefault?: boolean;
}) {
  const trackEvent = useTrackEvent();
  const [hasLoaded, setHasLoaded] = React.useState(false);
  const { currentUser, currentUserHasLoaded } = useSession();
  const { t } = useTranslation(
    "client\\components\\payments\\StripePaymentElement",
  );
  return (
    <Box
      sx={{ paddingBottom: pxToRem(28), ...containerSx }}
      data-test-id="stripe-payment-element"
    >
      {!hasLoaded && !currentUserHasLoaded && <Loading />}
      <Box>
        <Typography variant="h6" mb={8} mr={4} sx={{ display: "inline-block" }}>
          {t("Add a New Card")}
        </Typography>
        <Typography variant="caption" sx={{ color: "grey.600" }}>
          {t("(Powered by Stripe)")}
        </Typography>
        {willCardBeSavedAsDefault !== undefined && (
          <Box sx={{ marginBottom: 8 }}>
            {willCardBeSavedAsDefault ? (
              <Typography variant="body2" sx={{ color: "grey.600" }}>
                <Trans t={t}>
                  This payment method will be{" "}
                  <strong>set as your default</strong> and be used for all
                  future Outschool payments, including memberships and class
                  enrollments.
                </Trans>
              </Typography>
            ) : (
              <Typography variant="body2" sx={{ color: "grey.600" }}>
                {t(
                  "This payment method will only be used for this transaction unless you set it as your default.",
                )}
              </Typography>
            )}
          </Box>
        )}
      </Box>
      <PaymentElement
        onReady={() => setHasLoaded(true)}
        options={{
          defaultValues: {
            billingDetails: {
              name: currentUser?.name ?? payingUser?.name,
              email: currentUser?.email ?? payingUser?.email,
            },
          },
        }}
        onChange={e => {
          const updatedPaymentMethod =
            e.value.type === "card"
              ? StripePaymentElementPaymentMethod.card
              : // @ts-ignore
                StripePaymentElementPaymentMethod[e.value.type];
          setIsPaymentElementComplete(e.complete);
          if (paymentMethod !== updatedPaymentMethod) {
            trackEvent("payment_type_change", {
              type: e.value.type,
            });
          }
          setPaymentMethod(updatedPaymentMethod);
        }}
      />
    </Box>
  );
}
